module.exports = __webpack_public_path__ + "static/img/mumi-3.a8c7f7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/mumi-3.jpg
// module id = oyy+
// module chunks = 1